<div class="input-style">
  <input [(ngModel)]="searchString" name="{{inputName}}" matInput placeholder="{{placeHolderText}}"
         (keydown.enter)="commitChange()" maxlength="100" (change)="commitChange()">
  <button id="{{deleteButtonId}}" mat-button mat-icon-button *ngIf="searchString"
          (mousedown)="commitChange('')">
    <mat-icon>close</mat-icon>
  </button>
</div>
